module.exports = __webpack_public_path__ + "static/img/results_03.096c45a3.svg";